export const AppRoutes = {
  ACCUEIL_PATH: {
    route: "/",
    getPath() {
      return this.route;
    },
  },
  FINALISATION_PATH: {
    route: "/finalisation",
    getPath() {
      return this.route;
    },
  },
  CONTACT_SERVICE_PATH: {
    route: "/contactService",
    getPath() {
      return this.route;
    },
  },
  INFO_PERSO_PATH: {
    route: "/infoPerso",
    getPath() {
      return this.route;
    },
  },
  HISTO_CONNEXION_PATH: {
    route: "/historiqueConnexion",
    getPath() {
      return this.route;
    },
  },
  FACTURES_FER_PATH: {
    route: "/facturesFER",
    getPath() {
      return this.route;
    },
  },
  DOCUMENTS_FER_PATH: {
    route: "/documentsFER",
    getPath() {
      return this.route;
    },
  },
  RATTACHEMENT_PATH: {
    route: "/rattachement",
    getPath() {
      return this.route;
    },
  },
  ADMIN_PATH: {
    route: "/admin",
    getPath() {
      return this.route;
    },
  },

};
